module.exports = __webpack_public_path__ + "static/media/LokiFrame86.7c41761a.png";